'use client'

import { useEffect } from 'react'

declare global {
  interface Window {
    initGoogleMapService: () => void
  }
}

interface Props {
  apiKey: string
  onServiceLoaded?: () => void
}

/**
 * This component loads external services.
 * @service GoogleMaps
 */
export const GoogleMapsServicesProvider: React.FC<Props> = ({
  apiKey,
  onServiceLoaded
}: Props) => {
  /**
   * Loads Google Maps API.
   * @param {string} apiKey - Google Maps API Key.
   * @returns {void}
   */
  const loadGoogleMaps = (apiKey: string): void => {
    try {
      if (window.google && window.google.maps) {
        console.log('Google Maps ya está cargado.')
        onServiceLoaded?.()
        return
      }

      // Definir callback global para inicialización segura
      window.initGoogleMapService = () => {
        if (window.google?.maps?.places) {
          onServiceLoaded?.()
        } else {
          console.error('Error: Google Maps no se cargó completamente.')
        }
      }

      // Evitar cargas duplicadas del script
      if (document.querySelector(`script[src*="maps.googleapis.com"]`)) {
        console.warn('Intento de carga duplicado de Google Maps bloqueado.')
        return
      }

      // Crear y añadir el script
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=es&libraries=places,geometry&loading=async&callback=initGoogleMapService`
      script.async = true
      script.defer = true

      script.onerror = () => {
        console.error('Error al cargar Google Maps.')
      }

      document.head.appendChild(script)
    } catch (error) {
      console.error('Error inesperado al cargar Google Maps:', error)
    }
  }

  useEffect(() => {
    if (apiKey) {
      loadGoogleMaps(apiKey)
    }
  }, [apiKey])

  return null
}
